export default {
  common: {
    blocking: '阻斷性',
    quality: '品質',
    manifold: '流形',
    watertight: '密閉',
    meshReady: '可網格化',
    notMeshReady: '尚無法網格化',
    needsRepair: '需要修復',
    diagnosisFailed: 'Diagnosis 失敗',
    diagnosing: '診斷中…',
    dismiss: '關閉',
    backToOriginal: '返回原始版本',
    geometry: '幾何',
    blockingIssues_one: '{{count, number}} 項阻斷性問題',
    blockingIssues_other: '{{count, number}} 項阻斷性問題',
    qualityIssues: '{{count, number}} 項品質',
    advisoryCount: '{{count, number}} 項建議',
    issuesSuffix_one: '{{count, number}} 項問題',
    issuesSuffix_other: '{{count, number}} 項問題',
  },
  verdictCard: {
    // "Geometry is clean" refers specifically to the uploaded CAD file
    // (幾何原始檔) passing every topology check — distinguishing the
    // FILE state from the abstract shape avoids the 「幾何」 collision
    // with the generic word for "shape".
    clean: '幾何原始檔乾淨無誤',
    cleanSubtitle: '未發現拓撲或品質問題',
    meshReady: '可網格化',
    meshReadySubtitle: '僅剩建議性品質問題',
    needsRepair: '幾何原始檔需要修復',
    needsRepairSubtitle_one:
      '有 {{count, number}} 項阻斷性問題需在網格化前檢視',
    needsRepairSubtitle_other:
      '有 {{count, number}} 項阻斷性問題需在網格化前檢視',
  },
  verdictLine: {
    diagnosisFailed: 'Diagnosis 失敗',
    diagnosing: '診斷中…',
    wrap: 'Wrap — 無診斷',
    noSeat: '沒有 Diagnosis 席位',
    noSubscription: '沒有 Diagnosis 訂閱',
    clean: '乾淨',
    meshReady: '可網格化',
    advisory: '· {{count, number}} 項建議',
    blockingIssues_one: '項阻斷性問題',
    blockingIssues_other: '項阻斷性問題',
    quality: '· {{count, number}} 項品質',
  },
  findingsRail: {
    fixInChat: '在對話中修正',
    fixInChatHint: '將此問題告訴助理，助理可以編輯 CAD 來修正。',
    reviewStep: '檢視診斷結果',
    repairStep: '修復',
    repairNotNeeded: '無需修復',
    repairGuidance:
      '可行時,自動修復會在上傳時執行。其餘缺陷請在 CAD 工具中修正後,從資料庫上傳新版本,或從頂部列重新執行診斷。',
    beyondRepairTitle: '超出自動修復範圍',
    beyondRepairFallback: '自動修復無法修正標記的問題。',
    beyondRepairBody:
      '重新執行也無濟於事 — 夾點與自相交等缺陷沒有自動修復方式（癒合會使實體塌陷；熔合需要共用面，而非單一接觸點）。請在 CAD 中修正：將各實體聯集為一個共用面的實體，或設計上避開夾點。先前的版本可能仍可網格化 — 請於上方選取後在 MeshGen 開啟（缺陷附近的網格品質可能下降）。',
    loading: '{{verb}} {{version}}…',
    simplifyRejectedTitle: '已拒絕簡化',
    simplifyRejectedBody:
      '已捨棄建議的 CAD 簡化 — 先前的版本維持不變。請於上方選取以檢視其診斷結果。',
    diagnosisFailedTitle: 'Diagnosis 失敗',
    diagnosisFailedFallback:
      '無法分析幾何。請在 CAD 工具中啟用「修復幾何」後重新匯出。',
    noDiagnosis: '此幾何沒有可用的診斷結果。',
    wrapTitle: 'Wrap 匯入不進行診斷',
    wrapBody:
      'Wrap 會將部件封裝為單一乾淨的密閉表面，因此沒有需要診斷的項目 — 可直接進行網格化。',
    wrapPrepNote:
      '前處理方式在匯入時決定。若要改為診斷，請以 Repair 重新匯入檔案。',
    latestIssuesLabel: '最新已診斷版本的問題',
    blockingTitle: '阻斷性 — 需修復以取得乾淨網格',
    blockingNote:
      '拓撲錯誤。網格化仍可執行，但可能失敗或產生劣化的網格 — 建議修復 CAD。',
    qualityTitle: '品質 — 建議性',
    qualityNote: '不會阻斷網格化，但可能降低元素品質。',
    showLayer: '在檢視器中顯示 {{layer}}',
    hideLayer: '在檢視器中隱藏 {{layer}}',
    expandBodies: '顯示重疊的實體',
    collapseBodies: '隱藏重疊的實體',
    recommended: '建議',
    conformalFuseTooltip:
      '這是共形多區域組件 — 熔合會將各區域合併為單一實體（破壞 CHT），因此系統會先請您確認。',
    fuseTooltip:
      '將多餘、重疊的實體熔合為單一密閉實體 — 這是各部件相交時常見的修正方式。將建立一個新的 CAD 版本供您在保留前檢視。',
    simplifyCad: '簡化 CAD（熔合實體）',
    keepSeparateTooltip:
      '將各部件保留為獨立實體，並以共形（共用、匹配）介面進行網格化，而非熔合 — 當這些獨立實體是刻意設計時使用。',
    keepSeparateLink: '或保留為獨立實體（共形介面）',
    doneIn: '{{verb}} 耗時',
    allChecksPassed:
      '所有診斷檢查皆已通過。您可在 MeshGen 開啟此幾何，或於更換檔案後重新執行 Diagnosis。',
    repairAlreadyAttempted: '已嘗試修復',
    repairWithheld: '已略過自動修復',
    alreadyTriedBody:
      '自動修復已在此部件上執行過但未能解決，因此不會持續重試。可依現況在 MeshGen 開啟（若可網格化）、於下方簡化 CAD，或上傳修正後的檔案。',
    ineligibleOriginBody:
      '此版本來自您選擇的簡化或修復 — 自動修復不會在其之上執行。請檢視結果後在 MeshGen 開啟，或再試一次簡化。',
  },
  readinessChips: {
    combinedTooltip:
      '這些顯示此特定幾何依模擬類型可網格化的項目。同一部件可能適用於某一類型而不適用於另一類型 — 例如具有內壁的組件適合 FEA，但不適合外流 CFD。',
    staleTooltip:
      '此幾何是在加入網格就緒檢查之前診斷的。請重新執行 Diagnosis 以依模擬類型查看其可網格化的項目。',
    feaReady:
      '可用於 FEA（結構/熱/模態）。這是有效實體 — 可作為體積網格化。多實體組件會以各實體分組網格化（Volume_1、Volume_2…）以進行各實體材料/邊界條件指定 — 無需熔合；共用內壁亦無妨。',
    extReady:
      '可用於外流 CFD。乾淨的封閉實體，可包覆於風洞中網格化。互不重疊的多實體組件亦可。',
    intReady:
      '可用於內流 CFD。已從此部件擷取出完全封閉的內部空腔（流體體積）。',
    intNotReady: '內流 CFD：{{reason}}。',
    chtReady:
      '可用於共軛熱傳（CHT）。固體與流體區域共用共形介面 — 各自作為獨立區域並以匹配的共用邊界網格化（無需熔合）。重合的介面面/夾點屬預期現象，並非缺陷。',
    chtWarn:
      '可用於 CHT 網格化（共形固體＋流體）。介面自相交/共壁瑕疵可能使接縫附近的網格劣化，但各區域仍可網格化。',
    feaNotReadyNotReady:
      'FEA 尚不乾淨：{{reason}}。自相交實體會網格化為無效元素 — 請在求解前修復。',
    feaNotReadyWarn: 'FEA 尚不乾淨：{{reason}}。修復可改善元素品質。',
    extNotReady:
      '外流 CFD 尚不乾淨：{{reason}}。網格仍可產生（包覆容錯），但切割可能不乾淨且結果劣化。',
    chtNotReady: '尚無法用於 CHT：{{reason}}。',
    feaLabel: 'FEA',
    externalLabel: '外流 CFD',
    internalLabel: '內流 CFD',
    chtLabel: 'CHT',
    readyToMesh: '可網格化',
    aboutReadiness: '關於網格就緒',
    rerunToCheck: '重新執行 Diagnosis 以檢查。',
  },
  inspectorStrip: {
    found: '項',
    isolated: '已隔離',
    isolate: '隔離',
    closeInspector: '關閉檢視器',
    overlapPair: 'Vol {{a}} ↔ Vol {{b}}',
    overlapRegions: '×{{count, number}}',
    overlapUnresolved: '{{count, number}} 組無法辨識',
    overlapUnresolvedWhy:
      '此次診斷未能將這些重疊對應到實體：可能是診斷早於實體辨識功能，或兩個實體過於相似而無法區分。可重新執行診斷再試。',
    overlapCoincident: '共面',
    overlapInterference: '干涉',
    overlapDepthMm: '{{value}} mm',
    overlapDepthUm: '{{value}} µm',
    overlapSplit:
      '{{coincident, number}} 組共面 · {{interference, number}} 組干涉',
    overlapAllCoincident: '{{count, number}} 組共面',
    overlapAllInterference: '{{count, number}} 組干涉',
    overlapSelectPair: '選取 Vol {{a}} ↔ Vol {{b}}',
    overlapOpFor: 'Vol {{a}} ↔ Vol {{b}} 的處理方式',
    overlapOpChoose: '選擇…',
    overlapOpCut: '切除',
    overlapOpFragment: '分割',
    overlapOpFuse: '熔合',
    overlapOpExclude: '排除',
    overlapCutLoser: '切除 Vol {{loser}}',
    overlapCutLoserUnknown: '切除較大的實體',
    overlapSwapLoser: '改為切除 Vol {{loser}}',
    overlapTreatSelectedNone: '處理選取的配對',
    overlapTreatSelected_one: '處理選取的 {{count, number}} 組',
    overlapTreatSelected_other: '處理選取的 {{count, number}} 組',
    overlapTreatNone: '請至少選取一組配對來處理。',
    overlapTreatChooseOp:
      '請為每一組選取的配對選擇處理方式：此次診斷未量測它們，因此沒有預設值。',
    overlapTreatCompact: '處理 {{count, number}} 組',
    overlapTreatExplainer:
      '每一組重疊的配對都可以切除、分割、熔合或排除。勾選的配對會一起處理成新版本，供您核准或拒絕。',
    overlapOpCutMeaning: '從其中一個實體移除重疊的材料，使兩者剛好相接。',
    overlapOpFragmentMeaning:
      '將重疊部分分割成獨立實體，使介面共用（黏結、共用節點）。',
    overlapOpFuseMeaning: '將兩個實體合併為一個。',
    overlapOpExcludeMeaning:
      '兩者保持原樣，並記錄此配對為預期狀態。幾何不會改變，因此網格會如同未處理般對待它。',
    overlapCutLoserWhy: '失去材料的實體；另一個保持其形狀。',
    overlapFeaExplainerLabel: '共面與干涉在 FEA 網格中的意義',
    overlapDiagramCoincident: '兩個面合併，兩個實體共用節點。',
    overlapDiagramInterference:
      '重疊部分成為獨立實體。× 標示並非真實結果的邊緣應力。',
    overlapFeaExplainer:
      '以「共用節點 — 接合」建立的網格中：\n\n共面：兩個面通常會被合併，兩個實體共用節點並黏結在一起。接合處傳遞拉力、剪力與壓力，且永遠不會張開。\n\n干涉：重疊部分會成為與兩者黏結的獨立小實體，載重從中通過。其邊緣的應力並非真實結果；請將其切除，使兩個面剛好相接。\n\n在 SimOps 的網格中，黏結的配對計為「共享面」，未能合併的面計為「未連接配對」。未連接的面在新增束縛（tie）或接觸對之前不傳遞載重。黏結接合處邊緣的應力會隨網格加密持續升高，請在距離邊緣數個元素處讀取。以「獨立本體」建立的網格不會黏結任何東西，每個接合處都需要束縛或接觸對，且干涉仍須先切除。',
    overlapCoincidentFea:
      '兩個彼此相貼繪製的面，在檔案精度下並不完全吻合。共用節點的網格通常會將它們合併為一個黏結介面；分割會在 CAD 中做同樣的事。',
    overlapInterferenceFea:
      '兩個實體都佔用的材料。共用節點的網格會把它變成與兩者黏結的獨立小實體，載重集中從中通過，其邊緣的應力並非真實結果。切除會將其從其中一個實體移除（除非對調，否則為較大的實體），使兩者剛好相接，並以單一黏結面建立網格。',
  },
  approvalPanel: {
    fusing: '正在熔合多餘實體{{arrow}}…',
    treating_one: '正在處理 {{count, number}} 組重疊{{arrow}}…',
    treating_other: '正在處理 {{count, number}} 組重疊{{arrow}}…',
    fixing: '正在修正：{{defects}}',
    noSimplificationTitle: '未套用簡化',
    noSimplificationFallback: 'CAD 簡化並未改善幾何。',
    backToOriginal: '返回原始版本',
    eyebrowConformal: 'CAD 簡化 · 共形',
    eyebrowFuse: 'CAD 簡化 · 熔合',
    eyebrowTreatOverlaps: 'CAD 簡化 · 逐對處理',
    reviewTitle: '檢視簡化後的幾何',
    reviewDescription: '已編輯 CAD 以移除多餘的內部介面。',
    reject: '拒絕',
    approve: '核准',
    before: '之前',
    after: '之後',
    afterPending: '「之後」的計數尚不可用 — 熔合後的幾何會在您核准時完整診斷。',
    fusedIn: '熔合耗時',
    treatedIn: '處理耗時',
    outcomesTitle: '逐對結果',
    outcomeApplied: '已套用',
    outcomeRecorded: '已記錄',
    outcomeSkipped: '已略過：{{detail}}',
    outcomeFailed: '失敗：{{detail}}',
    treatedTotal: '已處理 {{treated, number}} / {{total, number}} 組',
    outcomesHighlightOnSource:
      '在處理後的版本重新診斷之前，標示只會顯示在原始版本上。',
    treatingPair: '{{pair}} · {{op}}',
    metric: '指標',
    beforeCol: '之前',
    beforeColLabeled: '之前 · {{label}}',
    afterCol: '之後',
    afterColLabeled: '之後 · {{label}}',
    solids: '實體',
    pinchPoints: '夾點',
    nonManifoldEdges: '非流形邊',
    badWinding: '錯誤纏繞',
    manifold: '流形',
    watertight: '密閉',
    yes: '是',
    no: '否',
  },
  noOpBanner: {
    fallback: 'CAD 簡化並未改變幾何。',
    noSimplificationApplied: '未套用簡化。',
    backToOriginal: '返回原始版本',
    dismiss: '關閉',
  },
  report: {
    reportEyebrow: 'Diagnosis 報告',
    geometry: '幾何',
    generated: '產生時間',
    meshReady: '可網格化',
    notMeshReady: '尚無法網格化',
    meshReadyDescription: '未偵測到阻斷性拓撲問題。',
    notMeshReadyDescription: '阻斷性拓撲問題需在網格化前檢視。',
    advisory: '{{count, number}} 項建議',
    advisoryDescription: '品質問題不會自動阻斷網格化。',
    meshReadiness: '網格就緒',
    manifold: '流形',
    watertight: '密閉',
    open: '開放',
    findings: '發現',
    blocking: '阻斷性',
    quality: '品質',
    noFindings: '未偵測到任何問題。',
    versionHistory: '版本歷程',
    yes: '是',
    no: '否',
  },
  reportDialog: {
    title: 'Diagnosis 報告',
    description: '檢視報告，或從瀏覽器列印對話框儲存。',
    printSave: '列印/儲存為 PDF',
  },
  conformalFuse: {
    title: '要熔合共形組件嗎？',
    description:
      '這是共形多區域組件（例如 CHT 固體＋流體）。熔合會將各區域合併為單一實體並破壞多區域設定 — 它可依現況用於 CHT 網格化，或使用「保留為獨立實體」以取得共形介面。僅在您確實需要單一實體時才熔合（例如以獨立兩半建模的 FEA 部件）。',
    keepSeparate: '保留獨立',
    fuseAnyway: '仍要熔合',
  },
  topBar: {
    draftPill: 'v{{version}} · 草稿 rev {{revision}}',
    exportSource: '匯出來源檔案',
    studyChip: '已附加研究：{{study}}',
    // 「診斷」— Diagnosis 產品的品牌名稱, 在其他文案沿用相同用字
    // 以維持一致性 (Diagnosis/MeshGen/SimOps 由 icon + 名稱識別,
    // 不靠顏色).
    productName: '診斷',
    backToLibrary: '返回資料庫',
    meshReady: '可網格化',
    meshableTooltip:
      '{{summary}}。幾何仍可網格化，但網格/結果可能劣化 — 修復 CAD 可改善品質。',
    meshableTooltipNoSummary:
      '幾何仍可網格化，但部分模擬類型可能產生劣化的網格 — 修復 CAD 可改善品質。',
    meshable: '可網格化',
    notReadyTooltip:
      '{{summary}}至少有一種模擬類型無法為此幾何建立網格 — 請在網格化前修復 CAD。',
    notMeshReady: '尚無法網格化',
    wrapImport: 'Wrap 匯入',
    wrapRerunTooltip: 'Wrap 匯入會略過診斷。若要診斷，請以 Repair 重新匯入。',
    diagnosisInProgress: 'Diagnosis 進行中…',
    rerunTooltip: '重新執行 Diagnosis',
    rerun: '重新執行',
    exportPdf: '匯出 PDF',
    exportOptions: '匯出選項',
    exportJson: '匯出 JSON',
    savePdfHint: '從瀏覽器對話框將可列印報告儲存為 PDF。',
    openInMeshgenDisabled: '幾何須為流形且密閉才能網格化',
    openInMeshgenReady: '在 MeshGen 開啟此幾何',
    openInMeshgenWarn: '流形且密閉 — 雖仍有部分標記問題，但您可進行網格化',
    openInMeshgen: '在 MeshGen 開啟',
  },
  library: {
    // Library surfaces list uploaded FILES, not abstract shapes — use
    // 幾何原始檔 so it doesn't collide with the generic 「幾何」.
    dropTitle: '拖放 CAD 檔案進行診斷',
    dropSubtitle:
      'STEP、STP、OBJ、STL · 最大 1 GB — 檢查流形性、密閉性與網格品質',
    recentGeometries: '最近的幾何原始檔',
    countLabel: '{{count, number}} 個已診斷',
    searchPlaceholder: '搜尋幾何原始檔…',
    all: '全部',
    meshReady: '可網格化',
    needsRepair: '需要修復',
    emptyTitle: '尚無已診斷的幾何原始檔',
    emptyTitleFiltered: '沒有符合篩選條件的幾何原始檔',
    emptyHint: '在上方上傳 CAD 檔案以執行您的第一次 Diagnosis。',
    emptyHintSearch:
      '已載入的幾何原始檔中沒有相符項目 — 請捲動以載入更多，或改用其他搜尋。',
    emptyHintFilter: '請嘗試其他篩選條件或搜尋字詞。',
    loadingLabel: '載入幾何原始檔中…',
    // 作為 `formatRelativeTime` 的 prefix, 形成「已診斷 3 天前」的顯示.
    // 明示為「Diagnosis 完成的時間點」而非一般時間.
    diagnosedPrefix: '已診斷',
    awaitingDiagnosis: '待診斷',
    notDiagnosed: '未診斷',
  },
  libraryRow: {
    geometry: '幾何原始檔',
    diagnosed: '已診斷',
    verdict: '結論',
    open: '開啟',
  },
  libraryCard: {
    repaired: '已修復',
  },
  thumbnail: {
    meshReady: '可網格化',
    needsRepair: '需要修復',
    failed: '失敗',
    needsApproval: '需要核准',
    diagnosing: '診斷中',
    wrap: 'Wrap',
    notDiagnosed: '未診斷',
  },
  viewerPanel: {
    loadingViewer: '載入檢視器中…',
  },
  fileTree: {
    files: '檔案（{{count, number}}）',
    diagnosing: '診斷中…',
    repairing: '修復中…',
    repairFailed: '修復失敗',
    diagnosisFailed: 'Diagnosis 失敗',
    clean: '乾淨',
    doneWith: '完成 · {{summary}}',
    simplifyRejected: '已拒絕簡化',
    viewVersion: '檢視版本 {{num}}（{{origin}}）',
    downloadSourceFile: '下載來源檔案',
    downloadVersion: '下載版本 {{num}} 來源檔案',
  },
  workspace: {
    lineageError: '無法載入幾何版本。',
    fixInChatBusy: '助理正在回覆，請等它完成。',
    dismiss: '關閉',
    rerunFailed: '重新執行失敗 — 請嘗試選取先前的版本。',
    simplifyFailed: '無法開始簡化。',
    resolveSimplifyFirst: '請先處理簡化（核准或拒絕）再重新執行 Diagnosis。',
    noGeometryToRediagnose: '此版本沒有可重新診斷的幾何 — 請選取先前的版本。',
    simplifyAwaitingReview: '已有一項簡化正等待您檢視 — 請先核准或拒絕。',
    lineageBusy: '另一個版本仍在診斷或修復中 — 請待其完成後再進行簡化。',
    simplifyInFlight: '已有一項簡化正在送出。',
    verbDiagnosing: '診斷',
    verbRepairing: '修復',
    verbDiagnosed: '診斷',
    verbRepaired: '修復',
  },
  tagAbbr: {
    non_manifold_edges: '非流形',
    non_manifold_vertices: '非流形頂點',
    boundary: '非密閉',
    winding_inconsistent_faces: '纏繞不一致',
    self_intersections: '自相交',
    overlapping_faces: '重疊面',
    degenerate_faces: '退化面',
    inter_volume_overlaps: '實體重疊',
    multi_revolution_surfaces: '多轉曲面',
    sharp_edges: '銳邊',
    ultra_thin_surfaces: '薄面',
    zero_length_edges: '零長邊',
    sliver_faces: '狹長面',
    clean: '乾淨',
  },
  severity: {
    clean: '幾何原始檔乾淨無誤',
    critical: '嚴重',
    blocking: '阻斷性',
    advisory: '建議',
    issuesDetected: '偵測到問題',
  },
  meta: {
    // Backward-translation test: 「5 實體」 unambiguously reads as
    // "5 solid bodies" (num_volumes in the CAD), where 「5 體積」 would
    // read as the generic mass noun "5 volume" and lose context.
    vol: '實體',
    surf: '表面',
    curv: '曲線',
    // 「對角長」— 邊界盒 (bounding box) 對角線的長度 (對角距離).
    // 只寫「對角」易被讀成「對角位置」, 加「長」明示為長度數值.
    diag: '對角長',
    sa: '表面積',
  },
  layers: {
    non_manifold_edges: { label: '非流形邊' },
    boundary: { label: '開放邊界' },
    winding_inconsistent_faces: { label: '不一致的環繞方向' },
    non_manifold_vertices: {
      label: '非流形頂點',
      hint: '夾點',
    },
    // 加上「線」— CAD 中的自相交是「面與面沿一條線相交」而生, 幾何上
    // 產生的是交線 (intersection line). 中譯保留「線」的字面以符合幾何語境.
    self_intersections: { label: '自相交線' },
    overlapping_faces: { label: '重疊面' },
    degenerate_faces: { label: '退化面' },
    inter_volume_overlaps: { label: '體積間重疊' },
    multi_revolution_surfaces: { label: '多次旋轉曲面' },
    sharp_edges: { label: '銳邊' },
    ultra_thin_surfaces: { label: '超薄曲面' },
    zero_length_edges: { label: '零長度邊' },
    sliver_faces: { label: '細長面' },
  },
  defectDescriptions: {
    non_manifold_edges: {
      what: '由超過兩個面共用的邊 — 網格器無法解析跨越它們的體積拓撲。',
      fix: '自動修復會縫合或分割這些邊；超過約 5k 時建議手動清理 CAD。',
    },
    boundary: {
      what: '表面未閉合成密閉固體的開放邊。',
      fix: '自動修復會封補小間隙；較大的開口需在 CAD 中補上缺少的面。',
    },
    winding_inconsistent_faces: {
      what: '相鄰面的法向量指向相反方向，破壞內外分類。',
      fix: '自動修復會從種子面重新調整繞向。',
    },
    non_manifold_vertices: {
      what: '夾點（非流形頂點） — 兩個固體或表面在單一點相接，使該處內部含糊不清。',
      fix: '在 CAD 中結合本體，使其共用一個面，而非在單一點接觸。自動修復通常無法解決此問題。',
    },
    self_intersections: {
      what: '穿過自身或彼此、產生糾纏拓撲的表面。',
      fix: '在 CAD 中對相交區域去特徵或修復 — 網格器無法解析它。',
    },
    overlapping_faces: {
      what: '佔據相同空間的重合或重疊面。',
      fix: '在 CAD 中移除重複面或合併本體。',
    },
    degenerate_faces: {
      what: '塌陷成線或點、面積實質為零的面。',
      fix: '以更緊的容差重新匯出，或在 CAD 中移除細長特徵。',
    },
    inter_volume_overlaps: {
      what: '相互穿透的獨立固體體積。',
      fix: '在網格化前，於 CAD 中將本體布林聯集或分離。',
    },
    multi_revolution_surfaces: {
      what: '旋轉超過 360° 而折回自身的表面。',
      fix: '在 CAD 中將旋轉裁剪為單圈。',
    },
    sharp_edges: {
      what: '比網格器預設二面角門檻（30°）更銳利的特徵邊。',
      fix: '建議性 — 除非抑制，否則會保留為特徵線。',
    },
    ultra_thin_surfaces: {
      what: '間距小於邊界盒對角線 0.01× 的表面對；會產生退化單元。',
      fix: '請考慮在 Mesh Settings 中進行去特徵或局部尺寸設定。',
    },
    zero_length_edges: {
      what: '端點重合的邊 — 在鑲嵌中長度為零。',
      fix: '建議性 — 匯入時以更緊的弦容差重新鑲嵌。',
    },
    sliver_faces: {
      what: '在來源鑲嵌中長寬比超過 50:1 的面。',
      fix: '建議性 — 匯入時以更緊的弦容差重新鑲嵌。',
    },
    fallback: {
      what: '診斷期間偵測到的幾何缺陷。',
      fix: '自動修復會在可行處嘗試修正；否則請在 CAD 中修復幾何。',
    },
  },
} as const;
